// 日记管理
// import {tkParse} from "@moke/vue-tk";
export default {
  className: 'diary',
  fields: [
    {
      name: 'user',
      width: 150,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'images',
      width: 150,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'content',
      width: 150,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'address',
      width: 150,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    }
  ],
  search: [
    'user',
    'content'
  ],
  action: {
    export: false,
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, className }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        // 刪除此条商家信息
        let rs = await vm.$tkParse.put('/classes/' + className + '/' + record.objectId, { isDelete: true }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: ''
          })
          vm.refresh()
        }
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDelete = false
    },
    beforeInsert ({ data }) {
      data.isDelete = false
    }
  }
}
